import { INTEGRATION_CONTACTS, extractIntegrationConfigurations } from './integrationConfigurationUtils';
import { MicrosoftConfig, MicrosoftLogin } from './integrationTypes';

export const INTEGRATION_LOGIN_MICROSOFT: MicrosoftLogin = {
  CODE: { name: 'code', defaultValue: '' },
};
export const INTEGRATION_LOGIN_MICROSOFT_HOME_ACCOUNT_ID = 'homeAccountId';
export const INTEGRATION_CONFIG_MICROSOFT_CACHE_CONTENT = 'cacheContent';
export const INTEGRATION_CONFIG_MICROSOFT_DELTA_TOKEN = 'deltaToken';

export const INTEGRATION_CONFIG_MICROSOFT: MicrosoftConfig = {
  CONTACTS: { name: INTEGRATION_CONTACTS, defaultValue: 'true' },
};

export const INTEGRATION_SCOPE_MICROSOFT = ['User.Read', 'openid', 'offline_access', 'Contacts.ReadWrite'];

export const microsoftDefaultConfigurations = {
  ...extractIntegrationConfigurations(INTEGRATION_LOGIN_MICROSOFT),
  ...extractIntegrationConfigurations(INTEGRATION_CONFIG_MICROSOFT),
  [INTEGRATION_LOGIN_MICROSOFT_HOME_ACCOUNT_ID]: '',
  [INTEGRATION_CONFIG_MICROSOFT_CACHE_CONTENT]: '',
  [INTEGRATION_CONFIG_MICROSOFT_DELTA_TOKEN]: '',
};
